module.exports = __webpack_public_path__ + "img/Michelin.54cd306e.png";